module.exports = __webpack_public_path__ + "img/community04.f6251526.png";